import { render } from "./GlobalMap.vue?vue&type=template&id=5dcfaa2d&scoped=true"
import script from "./GlobalMap.vue?vue&type=script&lang=js"
export * from "./GlobalMap.vue?vue&type=script&lang=js"

import "./GlobalMap.vue?vue&type=style&index=0&id=5dcfaa2d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcfaa2d"]])

export default __exports__